import { Component, OnInit } from '@angular/core';
import { FormlyType } from '../ga-formly.service';
import { ExtraFieldType } from '../extra-field-type';
import { GaFormlyUtil } from '../ga-formly.util';

@Component({
  selector: 'formly-field-input',
  // Fix for input type number to render as integer and not as string: https://github.com/ngx-formly/ngx-formly/pull/1172
  template: `
    <input *ngIf="to.type !== '${FormlyType.NUMBER}'; else numberTemplate"
      [type]="to.type || 'text'"
      class="form-control"
      [ngClass]="classNames"
      [placeholder]="to.placeholder"
      [attr.x-autocompletetype]="to.autoCompleteType"
      [attr.autocompletetype]="to.autoCompleteType"
      [formControl]="formControl"
      [formlyAttributes]="field"
      (blur)="to.onBlur && to.onBlur(formControl.value)"
      (mouseout)="to.onMouseOut && to.onMouseOut(formControl.value)"
      (keyup.enter)="to.onEnter && to.onEnter(formControl.value)"
      [maxlength]="to.maxLength"
      [minlength]="to.minLength"
      [inputFocus]="to.inputFocus"
    >
    <ng-template #numberTemplate>
      <input
        type="number"
        class="form-control"
        [ngClass]="classNames"
        [placeholder]="to.placeholder"
        [attr.x-autocompletetype]="to.autoCompleteType"
        [attr.autocompletetype]="to.autoCompleteType"
        [formControl]="formControl"
        (blur)="to.onBlur && to.onBlur(formControl.value)"
        (mouseout)="to.onMouseOut && to.onMouseOut(formControl.value)"
        (keyup.enter)="to.onEnter && to.onEnter(formControl.value)"
        [maxlength]="to.maxLength"
        [minlength]="to.minLength"
        [inputFocus]="to.inputFocus"
      >
    </ng-template>
  `
})
export class FormlyFieldInputComponent extends ExtraFieldType implements OnInit {
  constructor(
    private formlyUtil: GaFormlyUtil
  ) {
    super();
  }

  public ngOnInit():void {
    this.classNames = this.formlyUtil.createClassNames(FormlyType.INPUT, <string>this.key, this.to.label);

    // register listener
    this.listen();
  }
}